import styled from 'styled-components';

//helpers
import {center} from 'styles/helpers';

//components
import Icon from 'components/Icon';

export const CloudinaryPictureWithControls = styled.div`
  height: 100%;
  position: relative;
  width: 100%;

  &:not(:hover) {
    ${() => RefreshButton} {
      display: none;
    }
  }
`;

export const RefreshButton = styled.div`
  ${center};
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  height: 57px;
  opacity: 0.9;
  width: 57px;
`;

export const RefreshIcon = styled(Icon).attrs({
  name: 'refresh'
})`
  ${center};
`;
